var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "bulkImportFormRef",
          staticStyle: { margin: "20px" },
          attrs: { model: _vm.bulkImportForm, "label-position": "top" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "select_type_class",
                          model: {
                            value: _vm.bulkImportForm.numberType,
                            callback: function ($$v) {
                              _vm.$set(_vm.bulkImportForm, "numberType", $$v)
                            },
                            expression: "bulkImportForm.numberType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "运单号（Número de rastreio da Anjun）",
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "扫描单号（Código de barra）",
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t(
                            "collectionCenter.multiLineInputLimit"
                          ),
                          rows: 3,
                          type: "textarea",
                        },
                        on: { blur: _vm.BlockNewline },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.BlockNewline($event)
                          },
                        },
                        model: {
                          value: _vm.numberBox,
                          callback: function ($$v) {
                            _vm.numberBox = $$v
                          },
                          expression: "numberBox",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "事件类型（Tipo de evento）",
                        prop: "eventType",
                        rules: {
                          required: true,
                          message: _vm.$t("basicData.CannotBeEmpty"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.bulkImportForm.eventType,
                            callback: function ($$v) {
                              _vm.$set(_vm.bulkImportForm, "eventType", $$v)
                            },
                            expression: "bulkImportForm.eventType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "collectionCenter.discrepancyReport"
                              ),
                              value: 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "描述（Descrição）",
                        prop: "description",
                        rules: {
                          required: true,
                          message: _vm.$t("basicData.CannotBeEmpty"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          rows: 2,
                          type: "textarea",
                          clearable: "",
                          "show-word-limit": "",
                          maxlength: "500",
                        },
                        model: {
                          value: _vm.bulkImportForm.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.bulkImportForm, "description", $$v)
                          },
                          expression: "bulkImportForm.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "select_picture_class",
                      attrs: { label: "添加照片（Adicionar imagens）" },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "uploadRef",
                          staticClass: "avatar-uploader",
                          attrs: {
                            "show-file-list": true,
                            "file-list": _vm.imageList,
                            limit: 5,
                            "before-upload": _vm.beforeUpload,
                            "on-exceed": _vm.handleExceed,
                            "http-request": _vm.uploadDataClick,
                            "on-remove": _vm.handleRemove,
                            action: "#",
                            "list-type": "picture-card",
                            multiple: "",
                          },
                          model: {
                            value: _vm.photograph,
                            callback: function ($$v) {
                              _vm.photograph = $$v
                            },
                            expression: "photograph",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { color: "#606266", "font-size": "13px" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("collectionCenter.uploadImageLimit5")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "20px" } },
        [
          _c("el-button", { on: { click: _vm.bulkImportClose } }, [
            _vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.bulkImportSubmit } },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("GlobalSetObj.ImportResults"),
            visible: _vm.resultDialogVisible,
            width: "40%",
            "before-close": _vm.resultClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.resultDialogVisible = $event
            },
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "result_title_class" }, [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("collectionCenter.totalImported")) +
                    _vm._s(_vm.resultData.totalCount)
                ),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("orderCenterCont.ImportWasSuccessful")) +
                    _vm._s(_vm.resultData.successCount)
                ),
              ]),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("orderCenterCont.ImportFailed")) + " "),
                _c("span", { staticStyle: { color: "#af3e40" } }, [
                  _vm._v(_vm._s(_vm.resultData.failCount)),
                ]),
              ]),
            ]),
            _vm.resultData.failReasonList &&
            _vm.resultData.failReasonList.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.resultData.failReasonList, function (item, index) {
                    return _c("div", { key: index }, [
                      _vm._v(
                        " " +
                          _vm._s(index + 1) +
                          ". " +
                          _vm._s(item.waybillNumber) +
                          "，" +
                          _vm._s(item.reason) +
                          " "
                      ),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.resultClose } },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }